import { Card, CardActionArea, CardMedia } from '@material-ui/core'
import React from 'react'




const BlogCard = ({image, des}) => {
  return (
    <>
    <Card style={{maxWidth: '35rem', margin: 'auto' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="auto"
          width='auto'
          image={image}
          style={{hover: {
            "&:hover": {
              display: 'none'
            }
          }}}
        /> 
          <h3 style={{color: 'black', fontWeight: 'bolder'}}>
          {des}
          </h3>
      </CardActionArea>
    </Card>
    </>
  )
}

export default BlogCard